function swiperConfig(section, index) {
   const obj =  {
        1 : {
            slidesPerView: 4,
            spaceBetween: 20,
            navigation: {
                enabled: true,
                nextEl: section ? section.querySelector('.swiper-button-next') : '.swiper-button-next',
                prevEl: section ? section.querySelector('.swiper-button-prev') : '.swiper-button-prev',
            },
            pagination: {
                enabled: true,
                el: section ? section.querySelector('.swiper-pagination') : '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                '1': {
                    slidesPerView: 1,
                    spaceBetween: 12,
                    slidesOffsetBefore:20,
                    slidesOffsetAfter:20
                },
                '300': {
                    slidesPerView: 1.115,
                    slidesOffsetBefore:20,
                    slidesOffsetAfter:20,
                    spaceBetween: 12
                },
                '500': {
                    slidesPerView: 2,
                    slidesOffsetBefore:0,
                    slidesOffsetAfter:0
                },
                '768': {
                    spaceBetween: 20,
                    slidesPerView: 3,
                },
                '1024': {
                    slidesPerView: 4,
                }
            }
        },
        2: {
            slidesPerView: 5,
            spaceBetween: 20,
            navigation: {
                enabled: true,
                nextEl: section ? section.querySelector('.swiper-button-next') : '.swiper-button-next',
                prevEl: section ? section.querySelector('.swiper-button-prev') : '.swiper-button-prev',
            },
            // pagination: {
            //     enabled: true,
            //     el: section ? section.querySelector('.swiper-pagination') : '.swiper-pagination',
            //     clickable: true,
            //     dynamicBullets: true,
            // },
            breakpoints: {
                '1': {
                    slidesPerView: 1,
                    slidesOffsetBefore:20,
                    slidesOffsetAfter:20,
                    spaceBetween: 12
                },
                '300': {
                    slidesPerView: 1.40197,
                    slidesOffsetBefore:20,
                    slidesOffsetAfter:20,
                    spaceBetween: 12
                },
                '500': {
                    slidesPerView: 2,
                    slidesOffsetBefore:0,
                    slidesOffsetAfter:0
                },
                '768': {
                    spaceBetween: 20,
                    slidesPerView: 3,

                },
                '1024': {
                    slidesPerView: 4,

                },
                '1200': {
                    slidesPerView: 5,

                }
            }
        },
        3: {
            slidesPerView: 2,
            spaceBetween: 20,
            navigation: {
                enabled: true,
                nextEl: section ? section.querySelector('.swiper-button-next') : '.swiper-button-next',
                prevEl: section ? section.querySelector('.swiper-button-prev') : '.swiper-button-prev',
            },
            pagination: {
                enabled: true,
                el: section ? section.querySelector('.swiper-pagination') : '.swiper-pagination',
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets:8
            },
            on: {
    slideChange(sw) {
      const pag = sw.pagination.el.querySelector('.swiper-pagination-bullets-dynamic');
      const active = sw.pagination.el.querySelector('.swiper-pagination-bullet-active');
      if (!pag || !active) return;

      const offsetBase = active.offsetLeft - (pag.clientWidth / 2 - active.clientWidth / 2);

      // Чем меньше коэффициент, тем "раньше" начинается смещение
      const earlyFactor = 0.6; // 0.5 = по умолчанию, 0.3 — начнет раньше
      const offset = offsetBase * earlyFactor;

      pag.style.transform = `translateX(-${offset}px)`;
    }
  },
            breakpoints: { 
                '1': {
                    slidesPerView: 1,
                    slidesOffsetBefore:20,
                    slidesOffsetAfter:20,
                    spaceBetween: 10
                },
                '300': {
                    slidesPerView: 1.115,
                    slidesOffsetBefore:20,
                    slidesOffsetAfter:20,
                    spaceBetween: 10
                },
                '500': {
                    slidesPerView: 2,
                    slidesOffsetBefore:0,
                    slidesOffsetAfter:0
                },
                '768': {
                    spaceBetween: 20,
                    slidesPerView: 1.5,

                },
                '1024': {
                    slidesPerView: 2,

                }
            }
        
        },
        4 : {
            slidesPerView: 4,
            spaceBetween: 20,
            navigation: {
                enabled: true,
                nextEl: section ? section.querySelector('.swiper-button-next') : '.swiper-button-next',
                prevEl: section ? section.querySelector('.swiper-button-prev') : '.swiper-button-prev',
            },
            // pagination: {
            //     enabled: true,
            //     el: '.swiper-pagination',
            //     clickable: true,
            // },
            breakpoints: {
                '1': {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                '300': {
                    slidesPerView: 1,
                    spaceBetween: 10
                },
                '500': {
                    slidesPerView: 2,
                },
                '768': {
                    spaceBetween: 20,
                    slidesPerView: 3,
                },
                '1024': {
                    slidesPerView: 4,
                }
            }
        },
        5:{
            slidesPerView: 3,
            spaceBetween: 20,
            navigation: {
                enabled: true,
                nextEl: section ? section.querySelector('.swiper-button-next') : '.swiper-button-next',
                prevEl: section ? section.querySelector('.swiper-button-prev') : '.swiper-button-prev',
            },
            breakpoints: {
                '1': {
                    slidesPerView: 1.5,
                    slidesOffsetBefore:20,
                    slidesOffsetAfter:20
                },
                '300': {
                    slidesPerView: 1.5,
                    slidesOffsetBefore:20,
                    slidesOffsetAfter:20,
                },
                '500': {
                    slidesPerView: 2,
                    slidesOffsetBefore:0,
                    slidesOffsetAfter:0
                },
                '768': {
                    spaceBetween: 20,
                    slidesPerView: 3,
                },
                '1024': {
                    slidesPerView: 3,
                }
            }
        },
        6:{
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: {
                enabled: true,
                nextEl: section ? section.querySelector('.swiper-button-next') : '.swiper-button-next',
                prevEl: section ? section.querySelector('.swiper-button-prev') : '.swiper-button-prev',
            },
        },
        7:{
            slidesPerView: 4,
            spaceBetween: 20,
            navigation: {
                enabled: true,
                nextEl: section ? section.querySelector('.swiper-button-next') : '.swiper-button-next',
                prevEl: section ? section.querySelector('.swiper-button-prev') : '.swiper-button-prev',
            },
            pagination: {
                enabled: true,
                el: section ? section.querySelector('.swiper-pagination') : '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                '1': {
                    slidesPerView: 1,
                    slidesOffsetBefore:20,
                    slidesOffsetAfter:20
                },
                '300': {
                    slidesPerView: 1.115,
                    slidesOffsetBefore:20,
                    slidesOffsetAfter:20,
                },
                '500': {
                    slidesPerView: 2,
                    slidesOffsetBefore:0,
                    slidesOffsetAfter:0
                },
                '768': {
                    spaceBetween: 20,
                    slidesPerView: 3,
                },
                '1024': {
                    slidesPerView: 4,
                }
            }
        },
        9:{
            slidesPerView: 'auto',
            spaceBetween: 20,
            pagination: {
                enabled: true,
                el: section ? section.querySelector('.swiper-pagination') : '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                '1': {
                    slidesPerView: 1,
                },
                '500': {
                    slidesPerView: 'auto',
                    slidesOffsetBefore:0,
                    slidesOffsetAfter:0,
                },
                
            }
        },
        10: {
            slidesPerView: 1.37,
            spaceBetween: 12,
            slidesOffsetBefore:20,
            slidesOffsetAfter:20,
            navigation: {
                enabled: true,
                nextEl:'.recommendation-products-drawer .swiper-button-next',
                prevEl: '.recommendation-products-drawer .swiper-button-prev',
            },
            breakpoints: {
                '1': {
                    slidesPerView: 1.1,
                    slidesOffsetBefore:20,
                    slidesOffsetAfter:20,
                },
                '300': {
                    slidesPerView: 1.1,
                    slidesOffsetBefore:20,
                    slidesOffsetAfter:20,
                },
                '500': {
                    slidesPerView: 1.37
                },
                
            }
        }
    }
   return obj[index];

}

class CustomSlider extends HTMLElement {
    constructor() {
        super();
        this.dataIndex = this.dataset.index || 1;
        this.section = this.closest('.shopify-section');
        this.config = swiperConfig(this.section, this.dataIndex);
        this.swiper = new Swiper(this, this.config)
    }
}

customElements.define('custom-slider', CustomSlider);